import { useEffect, useState } from 'react';

import { styled } from 'styled-components';
const arrowIcon = '//static.szlcsc.com/ecp/assets/newWeb/smt/icon-right-c.png';
const CustomArrow = ({ width, isInner }) => {
  const StyleContent = styled.div`
    .leftBtn {
      left: ${isInner ? 15 : '-' + width}px;
    }
    .rightBtn {
      right: ${isInner ? 15 : '-' + width}px;
    }
    img {
      position: absolute;
      width: ${width}px;
      cursor: pointer;
      opacity: 0.5;
      top: 50%;
      margin-top: -${width / 2}px;
      z-index: 1;
      display: none;
    }
  `;
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    setIsShow(true);
  }, []);
  return (
    <>
      <section id="custom-prev-button" className={isShow ? 'block' : 'hidden'}>
        <StyleContent>
          <img src={arrowIcon} className="leftBtn rotate-[180deg]  hover:opacity-[1] custom-group-hover-block"></img>
        </StyleContent>
      </section>
      <section id="custom-next-button" className={isShow ? 'block' : 'hidden'}>
        <StyleContent>
          <img src={arrowIcon} className="rightBtn hover:opacity-[1] custom-group-hover-block"></img>
        </StyleContent>
      </section>
    </>
  );
};
export default CustomArrow;
